import { Box, Button, CircularProgress, Stack } from "@mui/material";
import { GlobalState } from "context/GlobalContext";
import React, { useEffect, useState } from "react";
import { pythonVmInstance } from "utils/AxiosInstances/RareboxPythonInstance";
import FileSaver from "file-saver";
import axios from "axios";
import { filterColArry } from "./data";
import { DownloadRounded } from "@mui/icons-material";
import RenderInputField from "components/CustomQueriesDashboard/ReusableComponents/RenderInputField/RenderInputField";
import { constraintsOptions, inputTypes, selectOptKeyName, getColDefaultValue, isColumnDefault } from "data/globalData";
import parseErrMsgFromError from "utils/errorFunctions/parseErrorMessageFromError";

const Git = () => {
	const { setSnackBar, snackBar, setSnackBarOpen, setLoadingOpen } = GlobalState();
	const [loading, setLoading] = useState(false);
	const [filterColumns, setFilterColumns] = useState(filterColArry);

	const defaultData = filterColArry?.reduce((acc, row) => {
		acc[row.key] = getColDefaultValue(row);
		return acc;
	}, {});

	const [filterData, setFilterData] = useState({ ...defaultData });
	const [dynamicFilterCols, setDynamicFilterCols] = useState(filterColArry);
	const fetchDropdownValues = async () => {
		// api call to fetch dropdown values.
		setLoadingOpen(true);
		const body = {
			table: "adroit-standard-379209.RTPLREP.GIT_VIEW",
			columns: ["SEASON", "DIVISION", "BRAND"],
		};
		try {
			await axios.post("/api/custom_queries/get_dropdown_value", body).then((res) => {
				console.log("first res", res.data);
				// setDropdownValues(res.data);
				setDynamicFilterCols((allColumns) => {
					let obj = res.data;
					return allColumns.map((row) => {
						if (obj[row.key] && [inputTypes.SELECT.key, inputTypes.MULTIPLE_SELECT.key].includes(row?.input_type)) {
							let opt = row[selectOptKeyName] ? row[selectOptKeyName] : {};
							opt = { ...opt, list: obj[row.key] };
							return { ...row, [selectOptKeyName]: opt };
						} else return row;
					});
				});
				setLoadingOpen(false);
			});
		} catch (error) {
			setLoadingOpen(false);
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "unable to fetch values for dropdown",
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
		}
	};
	useEffect(() => {
		const updated = filterColArry.map((col) => {
			// Always show Start Date, End Date, Type
			if (["start_date", "end_date", "type"].includes(col.key)) {
				return {
					...col,
					constraints: { ...col.constraints, DISPLAY: true, NOTNULL: true },
				};
			}

			// Show BRAND + SEASON only when type = full_data
			if (["BRAND", "SEASON", "DIVISION"].includes(col.key)) {
				return {
					...col,
					constraints: {
						...col.constraints,
						DISPLAY: filterData?.type === "full_data",
						// show only when full_data
						NOTNULL: filterData?.type === "full_data",
					},
				};
			}

			return col;
		});

		setDynamicFilterCols(updated); // store final list in state
		fetchDropdownValues();
	}, [filterData?.type]);

	const handleRunQueryClick = async (e) => {
		e.preventDefault();
		setLoadingOpen(true);
		let pendingFields = [];
		dynamicFilterCols?.forEach((attr) => {
			if (isColumnDefault(attr, filterData?.[attr?.key]) && attr?.constraints?.[constraintsOptions.NOTNULL.key] === true)
				pendingFields.push(attr);
		});

		if (pendingFields?.length) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: `Enter values for ${pendingFields.map((row) => row?.name)}`,
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);
			return;
		}
		await pythonVmInstance({
			url: `/custom_queries/git/download`,
			headers: {
				"Content-Type": "application/json",
			},
			method: "post",
			data: filterData,
			responseType: "blob",
		})
			.then((res) => {
				const url = URL.createObjectURL(res.data);
				FileSaver.saveAs(url, `git_${new Date().toISOString().split("T")[0]}.csv`);
				setLoadingOpen(false);
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: "Downloaded the file",
					severity: "success",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
			})
			.catch((err) => {
				console.log(err);
				setSnackBarOpen(true);
				setLoadingOpen(false);
				setSnackBar({
					...snackBar,
					message: parseErrMsgFromError(err),
					severity: "error",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
			});
	};

	return (
		<Stack spacing={2} component="form" onSubmit={handleRunQueryClick} pt={1}>
			{/* <Typography variant="h6">Inventory Snapshot Download</Typography> */}
			{/* <Typography variant="subtitle1" pt={2}> */}
			{/* Last synced with UC: {sync} */}
			{/* ⚠️ Temporary Unavailability <br />
                UC is currently updating their internal structure. The report download feature is temporarily unavailable. We
                appreciate your patience! */}
			{/* </Typography> */}
			{/* If the type is full data then only the Brand, Division and season showl be displayed. */}
			<Box display="flex" columnGap={2} flexWrap={"wrap"} justifyContent={""} rowGap={2}>
				{/* {filterColArry?.map((col) => {
					return (
						<RenderInputField
							column={col}
							data={filterData}
							setData={setFilterData}
							selectOptObjName={"select_options"}
							width={"20%"}
							longWidth={"300px"}
							disabled={false}
							disableLabel={true}
						/>
					);
				})} */}

				{dynamicFilterCols
					.filter((col) => col.constraints?.DISPLAY)
					.map((col) => (
						<RenderInputField
							key={col.key}
							column={col}
							data={filterData}
							setData={setFilterData}
							selectOptObjName="select_options"
							width="20%"
							longWidth="300px"
							disabled={false}
							disableLabel={true}
						/>
					))}
				<Box alignSelf="flex-end" pb={1}>
					<Button
						variant="contained"
						sx={{ width: "200px" }}
						type="submit"
						disabled={loading}
						startIcon={loading ? <CircularProgress color="inherit" size="20px" /> : <DownloadRounded />}>
						{loading ? "Loading..." : "Download"}
					</Button>
				</Box>
			</Box>
		</Stack>
	);
};

export default Git;
